<template>
    <section class="content">
        <div class="container-fluid">
            <div class="block-header">
                <h2>{{ name }}</h2>
            </div>
            <div class="row clearfix">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card">
                        <div class="header">
                            <h2>
                                Ubah {{ name }}
                            </h2>
                        </div>
                        <div class="body">
                            <form class="form-horizontal" @submit.prevent="save">
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="deskripsi">Deskripsi</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <Ckeditor id="deskripsi" v-model="data.deskripsi" :config="config"></Ckeditor>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                        <button v-bind:disabled="isLoading" type="submit" class="btn btn-primary" v-waves.button>
                                            <span v-if="!isLoading"><i class="material-icons">save</i> Kirim</span>
                                            <span v-else><i class="fa fa-spinner fa-spin"></i> Loading</span>
                                        </button>
                                        <button v-bind:disabled="isLoading" @click="$router.go(-1)" type="button" class="btn btn-danger" v-waves.button><i class="material-icons">cancel</i> Batal</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
  import Ckeditor from 'vue-ckeditor2'
  import FormLine from '@/components/FormLine.vue'
  import api from '@/helper/api'
  export default {
    components: {FormLine, Ckeditor},
    name: 'Form',
    data: function () {
      return {
        config: {
          toolbar: [
            { name: 'stuff', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
            { name: 'morestuff', items: ['NumberedList', 'BulletedList'] },

            { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'] },
            { name: 'colors', items: ['TextColor'] },
            { name: 'paragraph2', items: ['JustifyLeft', 'JustiftyCenter', 'JustifyRight', 'Outdent', 'Indent'] },
            '/',
            { name: 'document', items: ['Source'] }
          ],
          height: 300
        },
        data: {
          judul: '',
          tipe: 0,
          deskripsi: ''
        },
        isLoading: false,
        link: '',
        name: ''
      }
    },
    mounted () {
      this.checkRoute()
    },
    methods: {
      checkRoute () {
        if (this.$route.name === 'SyaratKepesertaan') {
          this.link = 'syarat'
          this.name = 'Syarat Kepesertaan'
          this.data.tipe = 9
        }

        if (this.$route.name === 'CaraMendaftar') {
          this.link = 'cara'
          this.name = 'Cara Mendaftar'
          this.data.tipe = 10
        }
        this.getData()
      },
      getData () {
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.get('/content-only?tipe=' + this.data.tipe).then((result) => {
          if (result.status === 200 && result.data) this.data = result.data
          this.data.judul = this.name
        }).catch(e => {
          var msg = 'Terjadi kesalahan pada server, mohon ulangi'
          if (e.response.data.message) msg = e.response.data.message
          this.$toastr.e(msg)
          this.isLoading = false
        })
      },
      save () {
        this.isLoading = true
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.post('/content-only', this.data).then((result) => {
          if (result.data.code === 200) {
            this.$toastr.s('Data berhasil disimpan')
          } else {
            var msg = 'Data gagal disimpan, silahkan coba kembali'
            if (result.data.message !== '') msg = result.data.message
            this.$toastr.e(msg)
          }
          this.isLoading = false
        }).catch(e => {
          var msg = 'Terjadi kesalahan pada server, mohon ulangi'
          if (e.response.data.message) msg = e.response.data.message
          this.$toastr.e(msg)
          this.isLoading = false
        })
      }
    },
    watch: {
      '$route' (to, from) {
        this.checkRoute()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/view/Form.vue?03e29aa0